module.exports = __webpack_public_path__ + "media/images/countrysquared/cd-4763aebb58848c9f3d57c57946b6369c.svg";